/**
 * Product Card Slideshow
 * Cycles through product images on desktop hover.
 * Plays video slides when encountered.
 * Desktop only — uses matchMedia to skip on touch/mobile.
 */
(function () {
  const INTERVAL_MS = 1200;
  const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (!isDesktop.matches) return;

  document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);

  /* Also init slideshows added later (e.g. AJAX pagination) */
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        node.querySelectorAll?.('[data-slideshow]').forEach(initSlideshow);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function initSlideshow(container) {
    if (container._slideshowInit) return;
    container._slideshowInit = true;

    const slides = container.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;

    const progress = container.querySelectorAll('[data-progress]');
    let current = 0;
    let timer = null;

    const card = container.closest('.product-card');
    if (!card) return;

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);

    function onEnter() {
      startTimer();
    }

    function onLeave() {
      clearInterval(timer);
      timer = null;
      pauseAllVideos();
      goTo(0);
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(() => advance(), INTERVAL_MS);
    }

    function advance() {
      const next = (current + 1) % slides.length;
      goTo(next);

      /* If the new slide is a video, pause interval and play video */
      const slide = slides[next];
      if (slide.tagName === 'VIDEO') {
        clearInterval(timer);
        timer = null;
        slide.currentTime = 0;
        slide.play().catch(() => {});
        /* When video ends, resume slideshow */
        slide.addEventListener('ended', () => {
          if (card.matches(':hover')) {
            advance();
            startTimer();
          }
        }, { once: true });
      }
    }

    function goTo(index) {
      slides[current].classList.remove('product-card__slide--active');
      if (progress[current]) progress[current].classList.remove('product-card__progress-bar--active');

      /* Pause video if leaving a video slide */
      if (slides[current].tagName === 'VIDEO') {
        slides[current].pause();
      }

      current = index;

      slides[current].classList.add('product-card__slide--active');
      if (progress[current]) progress[current].classList.add('product-card__progress-bar--active');
    }

    function pauseAllVideos() {
      slides.forEach((s) => {
        if (s.tagName === 'VIDEO') s.pause();
      });
    }
  }
})();
